export class CookieTableSettings {
  constructor(overrides) {
    const defaults = {
      nameText: 'Cookie Name',
      categoryText: 'Category',
      domainText: 'Domain',
      durationText: 'Duration',
      backgroundColor: '#f1f2f6',
      linkColor: '#0294ff',
      font: {
        fontSize: 12,
        fontWeight: '400',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      headerFont: {
        fontSize: 9,
        fontWeight: '400',
        color: '#000000',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      languages: {}
    };
    Object.assign(this, defaults, overrides);
  }
}
export const CookieTableTypes = {
  styles: {
    backgroundColor: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    font: {
      title: 'Font',
      type: 'Font'
    },
    headerFont: {
      title: 'Header Font',
      type: 'Font'
    },
    LinkColor: {
      title: 'Link Color',
      type: 'ColorPicker'
    }
  },
  text: {
    nameText: {
      title: 'Name Text',
      type: 'InputLanguage'
    },
    categoryText: {
      title: 'Category Text',
      type: 'InputLanguage'
    },
    domainText: {
      title: 'Domain Text',
      type: 'InputLanguage'
    },
    durationText: {
      title: 'Duration Text',
      type: 'InputLanguage'
    }
  }
};